import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter, Route } from 'react-router-dom'

const Router = ({ component }) => (
  <BrowserRouter forceRefresh={!window || !('pushState' in window.history)}>
    <Route component={component} />
  </BrowserRouter>
)

Router.propTypes = {
  component: PropTypes.func.isRequired,
}

export default Router



// WEBPACK FOOTER //
// ./src/browser/components/routing/Router.js